import { useEffect, useState } from 'react';
import { getSsoAccessToken } from '../utils/ssoToken';

type MediaBlobState = {
  blobUrl: string | null;
  loading: boolean;
  error: boolean;
};

export function useMediaBlobUrl(sourceUrl: string | null): MediaBlobState {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!sourceUrl) {
      setBlobUrl(null);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let objectUrl: string | null = null;
    let cancelled = false;

    setLoading(true);
    setError(false);

    const token = getSsoAccessToken().trim();

    fetch(sourceUrl, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Falha ao carregar o arquivo');
        }
        return response.blob();
      })
      .then(blob => {
        if (cancelled) {
          return;
        }
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setBlobUrl(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [sourceUrl]);

  return { blobUrl, loading, error };
}
